import { useMutation } from '@tanstack/react-query'
import { type PbUploadReturnDocumentsRequestDocument } from '@itsrever/rever-api'
import { processesApi } from '@/services/api/processes-api'

export type PreviewFile = {
  file: string
  preview: string
  description: string
}

interface UploadDocumentsVariables {
  processId: string
  documents: PbUploadReturnDocumentsRequestDocument[]
}

const uploadReturnDocuments = async ({
  processId,
  documents
}: UploadDocumentsVariables) => {
  const response = await processesApi.uploadReturnDocuments({
    processId,
    pbUploadReturnDocumentsRequest: {
      process_id: processId,
      documents
    }
  })
  return response.data
}

export const useUploadDocuments = () => {
  return useMutation({
    mutationFn: uploadReturnDocuments
  })
}
